// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1kj8ryw0 {
  width: 170px;
  background-color: #ffea00;
  top: 0;
  left: 0;
  border-radius: var(--_18w76bw46);
  line-height: var(--_18w76bw3k);
}
._109itzc1 ._1kj8ryw0, .autocomplete-hit-price-offer ._1kj8ryw0 {
  width: 100%;
  max-width: var(--_18w76bw18);
  border-radius: var(--_18w76bw47);
  font-size: var(--_18w76bw34);
  font-weight: var(--_18w76bw3g);
  text-decoration: none;
  padding: 3px 3.5px;
  border: 0;
}
.autocomplete-hit-price-offer ._1kj8ryw0 {
  top: unset;
  text-decoration: none;
  bottom: 0;
}
.q0scmm3 ._1kj8ryw0 {
  max-width: var(--_18w76bw17);
  padding: 3px 2.5px;
  border: 0;
  width: 100%;
}
._1kj8ryw1 {
  overflow-y: scroll;
  overflow-x: hidden;
  max-height: calc(100vh - 150px);
}
@media screen and (min-width: 768px) {
  ._1kj8ryw0 {
    width: var(--_18w76bwy);
    border: var(--_18w76bw45);
    border-radius: var(--_18w76bw47);
    border-color: var(--_18w76bw1r);
    padding: 10px 2px;
  }
  .autocomplete-hit-price-offer ._1kj8ryw0 {
    position: static;
  }
  ._1kj8ryw1 {
    max-height: calc(100vh - 200px);
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,yBAAyB;EACzB,MAAM;EACN,OAAO;EACP,gCAAgC;EAChC,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,4BAA4B;EAC5B,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,qBAAqB;EACrB,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,UAAU;EACV,qBAAqB;EACrB,SAAS;AACX;AACA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;AACjC;AACA;EACE;IACE,uBAAuB;IACvB,yBAAyB;IACzB,gCAAgC;IAChC,+BAA+B;IAC/B,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,+BAA+B;EACjC;AACF","sourcesContent":["._1kj8ryw0 {\n  width: 170px;\n  background-color: #ffea00;\n  top: 0;\n  left: 0;\n  border-radius: var(--_18w76bw46);\n  line-height: var(--_18w76bw3k);\n}\n._109itzc1 ._1kj8ryw0, .autocomplete-hit-price-offer ._1kj8ryw0 {\n  width: 100%;\n  max-width: var(--_18w76bw18);\n  border-radius: var(--_18w76bw47);\n  font-size: var(--_18w76bw34);\n  font-weight: var(--_18w76bw3g);\n  text-decoration: none;\n  padding: 3px 3.5px;\n  border: 0;\n}\n.autocomplete-hit-price-offer ._1kj8ryw0 {\n  top: unset;\n  text-decoration: none;\n  bottom: 0;\n}\n.q0scmm3 ._1kj8ryw0 {\n  max-width: var(--_18w76bw17);\n  padding: 3px 2.5px;\n  border: 0;\n  width: 100%;\n}\n._1kj8ryw1 {\n  overflow-y: scroll;\n  overflow-x: hidden;\n  max-height: calc(100vh - 150px);\n}\n@media screen and (min-width: 768px) {\n  ._1kj8ryw0 {\n    width: var(--_18w76bwy);\n    border: var(--_18w76bw45);\n    border-radius: var(--_18w76bw47);\n    border-color: var(--_18w76bw1r);\n    padding: 10px 2px;\n  }\n  .autocomplete-hit-price-offer ._1kj8ryw0 {\n    position: static;\n  }\n  ._1kj8ryw1 {\n    max-height: calc(100vh - 200px);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
